import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

/**
 * Video-camera glyph (camera body + lens) used for the in-call camera toggle.
 * Distinct from the `Video` icon, which is a play-button-in-frame.
 */
export const VideoCallIcon: React.FC<IconProps> = ({
  size = 24,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 26 24"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M18.4545 8.89062V13.1094L18.4545 20H1V2H18.4545L18.4545 8.89062ZM18.4545 13.1094L25 16.625V5.375L18.4545 8.89062"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </Svg>
);

VideoCallIcon.displayName = 'VideoCallIcon';
